import type { Position } from '@/voxelMath'

export function cellCenter(pos: Position): { x: number; y: number; z: number } {
  return { x: pos.x + 0.5, y: pos.y + 0.5, z: pos.z + 0.5 }
}

